import { Moment } from "moment";
import { OfficeEntity } from "./AdvanceHotDeskingService";
import { agent } from "@shared/services/agent";
import { DATE_FORMAT } from "@shared/utils/DateUtils";


export function getCarParkUtilizationForOffice(office: OfficeEntity | undefined, dateFrom: Moment, dateTo: Moment): Promise<CarParkUtilizationReport> {
  const officeParam = office ? `officeId=${office.id}&` : '';
  return agent.requests.get(`/api/report/car-park/utilization?${officeParam}fromDate=${dateFrom.format(DATE_FORMAT)}&toDate=${dateTo.format(DATE_FORMAT)}`);
}

export interface OfficeCarParkUtilization {
  officeId: number | null;
  officeLabel: string;
  capacity: number;
  totalBookings: number;
  daysInRange: number;
  utilizationPercentage: number;
  dailyBreakdown: CarParkDailyUtilization[];
  spaces: CarParkSpaceUtilization[];
}

interface CarParkSpaceUtilization {
  spaceId: number;
  label: string;
  officeId: number | null;
  officeLabel: string;
  totalBookings: number;
  daysInRange: number;
  utilizationPercentage: number;
}

export interface CarParkUtilizationReport {
  officeId: number | null;
  officeLabel: string;
  totalCapacity: number;
  totalBookings: number;
  daysInRange: number;
  utilizationPercentage: number;
  offices: OfficeCarParkUtilization[];
}

interface CarParkDailyUtilization {
  date: string;
  capacity: number;
  bookings: number;
  utilizationPercentage: number;
}
